import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		gcAdsenseModalVisible: false,
	},
	mutations: {
		showGcAdsenseModal(state) {
			document.querySelector('body').classList.add("no-scroll");
			state.gcAdsenseModalVisible = true;

			if (window.gtag) {
				window.gtag('event', 'gc.com ad modal shown', {
					'event_category': 'interaction'
				});
			}
		},
		hideGcAdsenseModal(state) {
			state.gcAdsenseModalVisible = false;

			document.querySelector('body').classList.remove("no-scroll");
		}
	},
	actions: {}
});

Grabcad = Grabcad || {};
Grabcad.communityAdsStore = store;

export default store;
